export default __webpack_public_path__ + "static/media/portal_mobile.2f94cbce.png";